/* eslint-disable no-redeclare */
import { z } from 'zod';

import type { AdServer, ProductType, SubProductType } from '../../types';

export const TrackingAdServer = z.enum([
  'featured-ads',
  'media-alpha',
  'ad-butler',
]);
export type TrackingAdServer = z.infer<typeof TrackingAdServer>;

export const TrackingProductName = z.enum([
  'health',
  'medicare',
  'life-insurance',
]);
export type TrackingProductName = z.infer<typeof TrackingProductName>;

export const TrackingSubProductName = z.enum([
  'aca',
  'medicare-generic',
  'medicare-advantage',
  'medicare-supplement',
]);
export type TrackingSubProductName = z.infer<typeof TrackingSubProductName>;

export const TrackingAdPlacement = z.enum(['typ']);
export type TrackingAdPlacement = z.infer<typeof TrackingAdPlacement>;

export interface AdContextDataV2
  extends Record<string, string | number | undefined> {
  ad_server: TrackingAdServer;
  advertiser_creative_id: string;
  advertiser_creative_title: string;
  advertiser_name?: string;
  advertiser_campaign_name?: string;
  publisher_ad_id: string;
  publisher_product_name: TrackingProductName;
  publisher_sub_product_name: TrackingSubProductName;
  publisher_placement: TrackingAdPlacement;
  impression_position: number;
  search_method?: string;
  product_fit?: string;
  group_id?: string;
}

export interface BuildAdContextV2Props {
  adServer: AdServer;
  advertiser: {
    creativeId: number;
    creativeTitle: string;
    name?: string;
    campaignName?: string;
  };
  publisher: {
    adId: string;
    productType: ProductType;
    subProductType?: SubProductType;
    placement: string;
  };
  impressionPosition: number;
  searchMethod?: string;
  productFit?: string;
  groupId?: number;
}
